// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tips-js": () => import("./../../../src/pages/tips.js" /* webpackChunkName: "component---src-pages-tips-js" */),
  "component---src-pages-work-docket-js": () => import("./../../../src/pages/work/docket.js" /* webpackChunkName: "component---src-pages-work-docket-js" */),
  "component---src-pages-work-skedul-js": () => import("./../../../src/pages/work/skedul.js" /* webpackChunkName: "component---src-pages-work-skedul-js" */),
  "component---src-templates-tip-template-js": () => import("./../../../src/templates/tipTemplate.js" /* webpackChunkName: "component---src-templates-tip-template-js" */)
}

